import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Button, Spin } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';

import '../InformView.css';
import { apiUrl } from '../../../utility/Connections';
import AreaReport from '../../../components/informs/managerialCrossGeneral/AreaReport';

const AreaInformView = () => {
    const { gcr_id, area_name } = useParams();
    const areaName = decodeURIComponent(area_name || '');

    const reportRef = useRef(null);
    const [showLoading, setShowLoading] = useState(true);
    const [pdfLoading,  setPdfLoading]  = useState(false);
    const [reportData,  setReportData]  = useState(null);
    const [orgLogo,     setOrgLogo]     = useState(null);

    useEffect(() => {
        fetchReport(gcr_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gcr_id]);

    const fetchReport = (runId) => {
        setShowLoading(true);
        const token   = localStorage.getItem('access_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        axios.get(`${apiUrl}/informs/get-managerial-cross-report/${runId}/`, headers)
            .then((res) => {
                const data  = res.data;
                setReportData(data);
                const orgId = data?.org_id
                    || data?.payload?.evaluations?.ipra?.org_id
                    || data?.payload?.evaluations?.iash?.org_id;
                if (orgId) {
                    fetchLogo(orgId);
                } else {
                    setShowLoading(false);
                }
            })
            .catch(() => { setReportData(null); setShowLoading(false); });
    };

    const fetchLogo = (orgId) => {
        axios.get(`${apiUrl}/organizations/get-organization-logo/${orgId}/`)
            .then((res) => { setOrgLogo(res.data.org_logo); })
            .catch(() => {})
            .finally(() => setShowLoading(false));
    };

    const handlePdfAction = async (action) => {
        if (!reportRef.current) return;
        setPdfLoading(true);
        try {
            if (action === 'download') await reportRef.current.downloadPdf();
            else                       await reportRef.current.openPdf();
        } finally {
            setPdfLoading(false);
        }
    };

    if (showLoading) {
        return (
            <div className="display-center-row display-center-column align-full-center managerial-cross-loading">
                <Spin size="large" tip={`Cargando informe de área — ${areaName}…`} />
            </div>
        );
    }

    if (!reportData) {
        return <div style={{ padding: 32 }}>Error al cargar el informe. Verifica el identificador y vuelve a intentarlo.</div>;
    }

    return (
        <div style={{ background: '#f7f7f7', minHeight: '100vh' }}>
            {/* Toolbar */}
            <div style={{
                position: 'sticky', top: 0, zIndex: 100,
                background: '#432b73', padding: '10px 24px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
            }}>
                <div style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>
                    Informe de Área — <span style={{ color: '#00b7a3' }}>{areaName}</span>
                    {reportData?.org_name && (
                        <span style={{ color: 'rgba(255,255,255,0.6)', fontWeight: 400, marginLeft: 8 }}>
                            · {reportData.org_name}
                        </span>
                    )}
                </div>
                <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    loading={pdfLoading}
                    onClick={() => handlePdfAction('download')}
                    style={{ background: '#00b7a3', borderColor: '#00b7a3' }}
                >
                    Descargar PDF
                </Button>
            </div>

            {/* Report */}
            <div style={{ padding: '24px 0' }}>
                <AreaReport
                    ref={reportRef}
                    reportData={reportData}
                    orgLogo={orgLogo}
                    orgName={reportData?.org_name}
                    areaName={areaName}
                />
            </div>
        </div>
    );
};

export default AreaInformView;
